<template lang="pug">
  .products
    .background-header.white
      v-container.white.pa-0(style="max-width:600px")
        .sticky-header-container(style="top:-1px" :style="editedWeight.length>0 ? 'height:125px' : 'height:60px'")
          .sticky-header(:class="!showHeader && editedWeight.length>0 ? 'hidden-header' : ''" )
            v-layout.ma-4
              div
                v-icon.mt-1(left color="black" :size="20" @click="backToPrev") mdi-arrow-left
              .h6.primary500--text.mt-1| {{ $t('set_product_weight') }}
            div.pa-4(flat outlined style="background-color:var(--v-successT08);" v-if="editedWeight.length>0" )
              v-row(no-gutters)
                v-col.text-start.align-self-center(cols="6")
                  div.p2.primary500--text {{ $t('you_made_count_changes', { count: editedWeight.length }) }}
                v-col(align='right')
                  v-btn.button-Aa-medium(text height="32" color='success500' :disabled="isSaving" @click='clearTask()') {{ $t('cancel') }}
                  v-btn.button-AA-medium.white--text(depressed color="success500" height="32" :loading="isSaving" @click="saveTask()" :disabled="disableSaveWeight") {{ $t('save') }}
        //- div()
        v-text-field.mx-4.my-2(v-model="searchText" placeholder='Search product' hide-details dense outlined height="40" background-color="basic200")
        v-divider.basic200
        v-form(ref="form")
          v-layout.pa-4.mb-n3
            v-text-field(v-model='weight' :placeholder="$t('weight.placeholder')" hide-details="auto" dense outlined height="40" background-color="basic200" type="number" min="0.1" max="60" step="0.1" persistent-hint :rules="weight ? rules.weight : []")
            v-btn.ml-2(color='textColorAccent' outlined height=40 :loading="isLoading" @click="startBulkUpdate" :disabled="weight == null || !weight" style="background-color:var(--v-infoT08)")
              .button-AA-medium(:class="!weight ? 'basic500--text' : 'info500--text'")| {{ $t('apply') }}
          v-layout.px-4.mb-n3
            eva-icon.mt-1.mr-1(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="16" )
            .align-self-center.c1.basic600--text| {{ $t('this_weight_will_applied') }}
              
    v-container.px-1(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        v-layout.my-6(v-if="products.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption {{ $t('products_not_found') }}
        .items-layout(v-else)
          .list-item.my-2(three-line)
            template(v-for='product in curretProducts')
              edit-product-item-weight(
                :product="product"
                :key="product.id"
                @editWeight="updateTask($event)"
                :focused="editedWeight.some(x => x.id==product.id)"
                :edited="editedWeight[editedWeight.findIndex(x => x.id==product.id)]"
              )
      y-pagination.mx-3.mt-4.mb-6(v-model="page" :pageSize="fetchCount" :count="totalCount")

</template>

<script>
import { mapActions } from 'vuex'
import queryString from 'query-string'
import EditProductItemWeight from '@/components/EditProductItemWeight.vue'

export default {
  name: 'SetupProducts',
  components: { EditProductItemWeight },
  props: ['company'],
  data: () => ({
    isFetching: false,
    isSaving: false,
    isTyping: false,
    fetchCount: 10,
    page: 1,
    totalCount: 0,
    products: [],
    searchText: '',
    weight: null,
    isLoading: false,
    searchCountDown: null,
    showHeader: true,
    lastScrollPosition: 0,
    rules: {
      weight: [
        v => v >= 0.1 || 'Weight should not be below 0.1 KG',
        v => v <= 60 || 'Weight should not be above 60 KG',
      ]
    },
    editedWeight: [],
  }),
  mounted () {
    if (!this.$route.query.page) {
      this.fetchProducts(1)
    } else {
      this.fetchProducts(this.$route.query.page)
    }
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  computed: {
    curretProducts () {
      return this.products
    },
    disableSaveWeight () {
      if (this.editedWeight.filter(f => f.weight < 0.1 || f.weight > 60).length > 0) {
        return true
      }
      return false
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    backToPrev(){
      this.$emit('back', null)
    },
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/products/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-weight`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.products = response.data.results
        this.totalCount = response.data.count
      }).catch(() => {})
    },
    clickAddProduct () {
      this.showAddProductDialog = true
    },
    searchItem () {
      let searchUrl = `/products/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.products = response.data.results
          this.totalCount = response.data.count
        }).catch(() => {})
    },
    async startBulkUpdate () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      for (var i = this.products.length; i--;) {
        let product = this.products[i]
        await this.axios.patch(`/products/${product.id}/`, { weight: this.weight })
        .then(response => {
          this.products[i] = response.data
          if (i === 0) {
            this.isLoading = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isLoading = false
          return
        })
      }
    },
    updateTask(product){
      var index = this.editedWeight.findIndex(x => x.id==product.id); 
      if (index === -1) {
        this.editedWeight.push(product)
      } else if (product.weight !== null){
        this.editedWeight[index].weight = product.weight
      } else {
        this.editedWeight.splice(index, 1);
      }
    },
    async saveTask () {
      this.isSaving = true
      for (const product of this.editedWeight) {
        await this.axios.patch(`/products/${product.id}/`, { weight: product.weight }).catch(() => {})
        // await this.axios.patch(`/products/${product.id}/`, { inventory_qty: product.quantity }).catch(() => {})
      }
      this.isSaving = false
      this.clearTask()
    },
    clearTask() {
      this.editedWeight = []
      this.products = []
      this.fetchProducts(1)
    },
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    },
  }
}
</script>

<style scoped>
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.clickable {
  cursor: pointer;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  /* height: 100px; */
}
.sticky-header{
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}
.sticky-header.hidden-header{
  transform: translate3d(0, -50%, 0) !important;
}
</style>

<i18n>
{
  "en": {
    "weight": {
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    },
    "set_product_weight": "Set product weight",
    "you_made_count_changes": "You have made {count} changes",
    "this_weight_will_applied": "This weight will be applied to all products in this page"
  },
   "en": {
    "weight": {
      "placeholder": "Min = 0.1 kg | Maks = 60 kg"
    },
    "set_product_weight": "Set berat produk",
    "you_made_count_changes": "Jumlah perubahan {count}",
    "this_weight_will_applied": "Berat ini akan diterapkan ke semua produk di halaman ini"
  }
}
</i18n>